export const countries = [
  ['af', 'Afghanistan'],
  ['ax', 'Åland Islands'],
  ['al', 'Albania'],
  ['dz', 'Algeria'],
  ['as', 'American Samoa'],
  ['ad', 'Andorra'],
  ['ao', 'Angola'],
  ['ai', 'Anguilla'],
  ['aq', 'Antarctica'],
  ['ag', 'Antigua and Barbuda'],
  ['ar', 'Argentina'],
  ['am', 'Armenia'],
  ['aw', 'Aruba'],
  ['au', 'Australia'],
  ['at', 'Austria'],
  ['az', 'Azerbaijan'],
  ['bs', 'Bahamas'],
  ['bh', 'Bahrain'],
  ['bd', 'Bangladesh'],
  ['bb', 'Barbados'],
  ['by', 'Belarus'],
  ['be', 'Belgium'],
  ['bz', 'Belize'],
  ['bj', 'Benin'],
  ['bm', 'Bermuda'],
  ['bt', 'Bhutan'],
  ['bo', 'Bolivia'],
  ['ba', 'Bosnia and Herzegovina'],
  ['bw', 'Botswana'],
  ['bv', 'Bouvet Island'],
  ['br', 'Brazil'],
  ['io', 'British Indian Ocean Territory'],
  ['bn', 'Brunei Darussalam'],
  ['bg', 'Bulgaria'],
  ['bf', 'Burkina Faso'],
  ['bi', 'Burundi'],
  ['kh', 'Cambodia'],
  ['cm', 'Cameroon'],
  ['ca', 'Canada'],
  ['cv', 'Cape Verde'],
  ['ky', 'Cayman Islands'],
  ['cf', 'Central African Republic'],
  ['td', 'Chad'],
  ['cl', 'Chile'],
  ['cn', 'China'],
  ['cx', 'Christmas Island'],
  ['cc', 'Cocos (Keeling) Islands'],
  ['co', 'Colombia'],
  ['km', 'Comoros'],
  ['cg', 'Congo'],
  ['cd', 'The Democratic Republic of The Congo'],
  ['ck', 'Cook Islands'],
  ['cr', 'Costa Rica'],
  ['ci', "Cote D'ivoire"],
  ['hr', 'Croatia'],
  ['cu', 'Cuba'],
  ['cy', 'Cyprus'],
  ['cz', 'Czechia'],
  ['dk', 'Denmark'],
  ['dj', 'Djibouti'],
  ['dm', 'Dominica'],
  ['do', 'Dominican Republic'],
  ['ec', 'Ecuador'],
  ['eg', 'Egypt'],
  ['sv', 'El Salvador'],
  ['gq', 'Equatorial Guinea'],
  ['er', 'Eritrea'],
  ['ee', 'Estonia'],
  ['et', 'Ethiopia'],
  ['fk', 'Falkland Islands (Malvinas)'],
  ['fo', 'Faroe Islands'],
  ['fj', 'Fiji'],
  ['fi', 'Finland'],
  ['fr', 'France'],
  ['gf', 'French Guiana'],
  ['pf', 'French Polynesia'],
  ['tf', 'French Southern Territories'],
  ['ga', 'Gabon'],
  ['gm', 'Gambia'],
  ['ge', 'Georgia'],
  ['de', 'Germany'],
  ['gh', 'Ghana'],
  ['gi', 'Gibraltar'],
  ['gr', 'Greece'],
  ['gl', 'Greenland'],
  ['gd', 'Grenada'],
  ['gp', 'Guadeloupe'],
  ['gu', 'Guam'],
  ['gt', 'Guatemala'],
  ['gg', 'Guernsey'],
  ['gn', 'Guinea'],
  ['gw', 'Guinea-bissau'],
  ['gy', 'Guyana'],
  ['ht', 'Haiti'],
  ['hm', 'Heard Island and Mcdonald Islands'],
  ['va', 'Holy See (Vatican City State)'],
  ['hn', 'Honduras'],
  ['hk', 'Hong Kong'],
  ['hu', 'Hungary'],
  ['is', 'Iceland'],
  ['in', 'India'],
  ['id', 'Indonesia'],
  ['ir', 'Islamic Republic of Iran'],
  ['iq', 'Iraq'],
  ['ie', 'Ireland'],
  ['im', 'Isle of Man'],
  ['il', 'Israel'],
  ['it', 'Italy'],
  ['jm', 'Jamaica'],
  ['jp', 'Japan'],
  ['je', 'Jersey'],
  ['jo', 'Jordan'],
  ['kz', 'Kazakhstan'],
  ['ke', 'Kenya'],
  ['ki', 'Kiribati'],
  ['kp', "Democratic People's Republic of Korea"],
  ['kr', 'Republic of Korea'],
  ['kw', 'Kuwait'],
  ['kg', 'Kyrgyzstan'],
  ['la', "Lao People's Democratic Republic"],
  ['lv', 'Latvia'],
  ['lb', 'Lebanon'],
  ['ls', 'Lesotho'],
  ['lr', 'Liberia'],
  ['ly', 'Libyan Arab Jamahiriya'],
  ['li', 'Liechtenstein'],
  ['lt', 'Lithuania'],
  ['lu', 'Luxembourg'],
  ['mo', 'Macao'],
  ['mk', 'The Former Yugoslav Republic of Macedonia'],
  ['mg', 'Madagascar'],
  ['mw', 'Malawi'],
  ['my', 'Malaysia'],
  ['mv', 'Maldives'],
  ['ml', 'Mali'],
  ['mt', 'Malta'],
  ['mh', 'Marshall Islands'],
  ['mq', 'Martinique'],
  ['mr', 'Mauritania'],
  ['mu', 'Mauritius'],
  ['yt', 'Mayotte'],
  ['mx', 'Mexico'],
  ['fm', 'Federated States of Micronesia'],
  ['md', 'Republic of Moldova'],
  ['mc', 'Monaco'],
  ['mn', 'Mongolia'],
  ['me', 'Montenegro'],
  ['ms', 'Montserrat'],
  ['ma', 'Morocco'],
  ['mz', 'Mozambique'],
  ['mm', 'Myanmar'],
  ['na', 'Namibia'],
  ['nr', 'Nauru'],
  ['np', 'Nepal'],
  ['nl', 'Netherlands'],
  ['an', 'Netherlands Antilles'],
  ['nc', 'New Caledonia'],
  ['nz', 'New Zealand'],
  ['ni', 'Nicaragua'],
  ['ne', 'Niger'],
  ['ng', 'Nigeria'],
  ['nu', 'Niue'],
  ['nf', 'Norfolk Island'],
  ['mp', 'Northern Mariana Islands'],
  ['no', 'Norway'],
  ['om', 'Oman'],
  ['pk', 'Pakistan'],
  ['pw', 'Palau'],
  ['ps', 'Occupied Palestinian Territory'],
  ['pa', 'Panama'],
  ['pg', 'Papua New Guinea'],
  ['py', 'Paraguay'],
  ['pe', 'Peru'],
  ['ph', 'Philippines'],
  ['pn', 'Pitcairn'],
  ['pl', 'Poland'],
  ['pt', 'Portugal'],
  ['pr', 'Puerto Rico'],
  ['qa', 'Qatar'],
  ['re', 'Reunion'],
  ['ro', 'Romania'],
  ['ru', 'Russian Federation'],
  ['rw', 'Rwanda'],
  ['sh', 'Saint Helena'],
  ['kn', 'Saint Kitts and Nevis'],
  ['lc', 'Saint Lucia'],
  ['pm', 'Saint Pierre and Miquelon'],
  ['vc', 'Saint Vincent and The Grenadines'],
  ['ws', 'Samoa'],
  ['sm', 'San Marino'],
  ['st', 'Sao Tome and Principe'],
  ['sa', 'Saudi Arabia'],
  ['sn', 'Senegal'],
  ['rs', 'Serbia'],
  ['sc', 'Seychelles'],
  ['sl', 'Sierra Leone'],
  ['sg', 'Singapore'],
  ['sk', 'Slovakia'],
  ['si', 'Slovenia'],
  ['sb', 'Solomon Islands'],
  ['so', 'Somalia'],
  ['za', 'South Africa'],
  ['gs', 'South Georgia and The South Sandwich Islands'],
  ['es', 'Spain'],
  ['lk', 'Sri Lanka'],
  ['sd', 'Sudan'],
  ['sr', 'Suriname'],
  ['sj', 'Svalbard and Jan Mayen'],
  ['sz', 'Swaziland'],
  ['se', 'Sweden'],
  ['ch', 'Switzerland'],
  ['sy', 'Syrian Arab Republic'],
  ['tw', 'Taiwan, Province of China'],
  ['tj', 'Tajikistan'],
  ['tz', 'United Republic of Tanzania'],
  ['th', 'Thailand'],
  ['tl', 'Timor-leste'],
  ['tg', 'Togo'],
  ['tk', 'Tokelau'],
  ['to', 'Tonga'],
  ['tt', 'Trinidad and Tobago'],
  ['tn', 'Tunisia'],
  ['tr', 'Turkey'],
  ['tm', 'Turkmenistan'],
  ['tc', 'Turks and Caicos Islands'],
  ['tv', 'Tuvalu'],
  ['ug', 'Uganda'],
  ['ua', 'Ukraine'],
  ['ae', 'United Arab Emirates'],
  ['gb', 'United Kingdom'],
  ['us', 'United States'],
  ['um', 'United States Minor Outlying Islands'],
  ['uy', 'Uruguay'],
  ['uz', 'Uzbekistan'],
  ['vu', 'Vanuatu'],
  ['ve', 'Venezuela'],
  ['vn', 'Viet Nam'],
  ['vg', 'Virgin Islands, British'],
  ['vi', 'Virgin Islands, U.S.'],
  ['wf', 'Wallis and Futuna'],
  ['eh', 'Western Sahara'],
  ['ye', 'Yemen'],
  ['zm', 'Zambia'],
  ['zw', 'Zimbabwe'],
];

export const COUNTRIES_CODES = new Map(countries);
export const COUNTRIES_NAMES = new Map(
  structuredClone(countries).map((c) => c.reverse()),
);

/**
 * Retrieve the country name
 * @param {String} code The 2 chars ISO code
 * @returns {String}
 */
export function ISOcodeToCountryName(code) {
  return COUNTRIES_CODES.get(code);
}

/**
 * Retrieve the country ISO code
 * @param {String} name The country name
 * @returns {String}
 */
export function countryNameToISOCode(name) {
  return COUNTRIES_NAMES.get(name);
}

export default countries;

export const countries_tax_type = {
  ae: () => 'ae_trn',
  au: () => 'au_abn',
  br: (vatId) => {
    if (/\//u.test(vatId)) {
      return 'br_cnpj';
    }
    return 'br_cpf';
  },
  ca: (vatId) => {
    if (/^[0-9]+$/u.test(vatId)) {
      return 'ca_bn';
    }
    return 'ca_qst';
  },
  ch: () => 'ch_vat',
  cl: () => 'cl_tin',
  es: (vatId) => {
    if (/^es.*/iu.test(vatId)) {
      return 'eu_vat';
    }
    return 'es_cif';
  },
  hk: () => 'hk_br',
  id: () => 'id_npwp',
  in: () => 'in_gst',
  jp: () => 'jp_cn',
  kr: () => 'kr_brn',
  li: () => 'li_uid',
  mx: () => 'mx_rfc',
  no: () => 'no_vat',
  nz: () => 'nz_gs',
  ru: () => 'ru_inn',
  sa: () => 'sa_va',
  th: () => 'th_vat',
  tw: () => 'tw_vat',
  us: () => 'us_ein',
  za: () => 'za_va',
  my: (vatId) => {
    if (/^[0-9]+$/u.test(vatId)) {
      return 'my_frp';
    }

    if (/^c.*/iu.test(vatId)) {
      return 'my_itn';
    }

    return 'my_sst';
  },
  sg: (vatId) => {
    if (/^m.*/iu.test(vatId)) {
      return 'sg_gst';
    }
    return 'sg_uen';
  },
  at: () => 'eu_vat',
  be: () => 'eu_vat',
  bg: () => 'eu_vat',
  cy: () => 'eu_vat',
  cz: () => 'eu_vat',
  de: () => 'eu_vat',
  dk: () => 'eu_vat',
  ee: () => 'eu_vat',
  fi: () => 'eu_vat',
  fr: () => 'eu_vat',
  gb: (vatId) => {
    // Check for Northern Ireland tax id.
    if (/^xi/iu.test(vatId)) {
      return 'eu_vat';
    }
    return 'gb_vat';
  },
  uk: () => 'eu_vat',
  gr: () => 'eu_vat',
  hr: () => 'eu_vat',
  hu: () => 'eu_vat',
  ie: () => 'eu_vat',
  it: () => 'eu_vat',
  lt: () => 'eu_vat',
  lu: () => 'eu_vat',
  lv: () => 'eu_vat',
  mt: () => 'eu_vat',
  nl: () => 'eu_vat',
  pl: () => 'eu_vat',
  pt: () => 'eu_vat',
  ro: () => 'eu_vat',
  se: () => 'eu_vat',
  si: () => 'eu_vat',
  sk: () => 'eu_vat',
};
